import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const stockAnalysisURL = "api/v1/stock-analysis-app/stock-reports";

//obtaining the paginated data

//obtaining the paginated data
export const getStockAnalysis = ({ rowsPerPage, search, sortOrder, pageNo, branch = null, product = null }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${stockAnalysisURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}&branch=${
      branch ? branch?.id : ""
    }&product=${product ? product?.id : ""}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllStockAnalysis = () => axiosInstance.get(`${stockAnalysisURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageStockAnalysis = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${stockAnalysisURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

// get by id
export const getStockAnalysisByItem = (id) => axiosInstance.get(`${stockAnalysisURL}?item=${id}`);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${stockAnalysisURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

export const getStockByIdAndBranch = (id, branchId) =>
  axiosInstance.get(`api/v1/stock-analysis-app/stock-reports/list?branch=${branchId}&product=${id}`);
